export const formationPositions = {
  // 6 tegen 6
  '1-2-1-2': [1, 3, 2, 4, 5, 6],
  '1-2-2-1': [1, 2, 3, 4, 5, 6],
  '1-2-3': [1, 2, 3, 4, 6, 5],
  '1-3-2': [1, 2, 3, 4, 5, 6],
  // 8 tegen 8
  '1-2-3-2': [1, 2, 3, 4, 5, 6, 7, 8],
  '1-3-1-3': [1, 2, 3, 4, 5, 6, 8, 7],
  '1-3-2-2': [1, 2, 3, 4, 5, 6, 7, 8],
  '1-3-3-1': [1, 2, 3, 4, 5, 6, 7, 8],
  // 11 tegen 11
  '1-3-4-3': [1, 2, 3, 4, 5, 10, 6, 8, 7, 9, 11],
  '1-4-3-3': [1, 2, 3, 4, 5, 6, 10, 8, 7, 9, 11],
  '1-4-4-2': [1, 2, 3, 4, 5, 7, 10, 6, 8, 9, 11],
  '1-5-3-2': [1, 2, 3, 6, 4, 5, 7, 10, 8, 9, 11]
}

const getFormationPosition = (formation, position) => {
  if (formationPositions[formation]) {
    return formationPositions[formation][position]
  } else {
    return position + 1
  }
}

export default getFormationPosition
